import { ForgotPasswordPageProps, useTranslate } from '@refinedev/core'
import {
  CardProps,
  Form,
  FormProps,
  Input,
  LayoutProps,
  Typography,
} from 'antd'
import React from 'react'
import { useNavigate } from 'react-router-dom'
// import { ReactComponent as SmartLogo } from '../../../../common/images/svg/SmartIcon.svg'
import { ReactComponent as SmartLogo } from '../../../../common/images/svg/SmartIconHover.svg'
import { CustomButton } from '../../../../components/button/buttonCustom'
import { ButtonTransparent } from '../../../../components/button/buttonTransparent'
import LoadingOverlay from '../../../../components/loading/loadingOverlay'
import {
  clearFieldErrorMessageOnChange,
  onlyLatinCharsDigitsSpecialSymbolsRule,
} from '../../../../utils/form.constants'
import useAuth from '../../../../utils/hooks/useAuth'
import useResponsive from '../../../../utils/hooks/useResponsive'
import { ThemedTitle } from '../../../themedLayout/title'
import { PageDescriptionStyles, PageTitleStyles } from './styles'

type ResetPasswordProps = ForgotPasswordPageProps<
  LayoutProps,
  CardProps,
  FormProps
>

export const ForgotPasswordPage: React.FC<
  ResetPasswordProps & { description?: React.ReactNode }
> = ({ formProps, title, description }) => {
  const [form] = Form.useForm<{ email: string }>()
  const translate = useTranslate()
  const { isTablet } = useResponsive()
  const navigate = useNavigate()

  const requiredFields = ['email']
  const [isAllFieldsFilled, setIsAllFieldsFilled] = React.useState(false)

  const { forgotPassword, loadingForgotPassword } = useAuth()

  const onFinish = (values: { email: string }) => {
    forgotPassword(values)
  }

  const checkAllFieldsFilled = () => {
    const values = form.getFieldsValue(requiredFields as any)
    return requiredFields.every((field) => !!values[field])
  }

  const PageTitle =
    title === false ? null : (
      <div style={{ ...PageTitleStyles }}>
        {title ?? <ThemedTitle collapsed={false} />}
      </div>
    )

  const Description =
    description === false ? null : (
      <Typography style={{ ...PageDescriptionStyles }}>
        {description ?? <ThemedTitle collapsed={false} />}
      </Typography>
    )

  const CardContent = (
    <Form
      style={{ width: '100%' }}
      layout='vertical'
      form={form}
      onFinish={onFinish}
      requiredMark={false}
      {...formProps}
      onValuesChange={() => {
        clearFieldErrorMessageOnChange(form)
        setIsAllFieldsFilled(checkAllFieldsFilled())
      }}>
      <div className='auth-form'>
        <Form.Item
          label='Email'
          name='email'
          className='testClassName'
          style={{ marginTop: '-15px' }}
          validateTrigger='onBlur'
          rules={[
            onlyLatinCharsDigitsSpecialSymbolsRule,
            {
              required: true,
              validateTrigger: 'onBlur',
              message: 'This field is required',
            },
            {
              type: 'email',
              message: translate(
                'pages.forgotPassword.errors.validEmail',
                'Invalid email address'
              ),
              validateTrigger: 'onBlur',
            },
          ]}>
          <Input
            size='large'
            placeholder={translate(
              'pages.forgotPassword.fields.email',
              'Enter email address'
            )}
          />
        </Form.Item>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
          <CustomButton
            text={translate(
              'pages.forgotPassword.buttons.submit',
              'Reset Password'
            )}
            width={'100%'}
            type='submit'
            size={isTablet ? 'medium' : 'large'}
            disabled={!isAllFieldsFilled}
          />
          <ButtonTransparent
            width={'100%'}
            size={isTablet ? 'medium' : 'large'}
            text={'Back'}
            onClick={() => {
              if (loadingForgotPassword) return
              // navigate(-1)
              navigate('/login')
            }}
            textClassName='text-button-back'
          />
        </div>
      </div>
    </Form>
  )

  return (
    <div className='auth-box'>
      <div className='auth-render'>
        {PageTitle}
        {Description}
        {CardContent}
      </div>
      <SmartLogo className='auth-logo' style={{ width: 56, height: 46 }} />
      <LoadingOverlay loading={loadingForgotPassword} />
    </div>
  )
}
